import { Drawer, Box, IconButton, Typography } from '@mui/material';
import { useUtiles } from '../context/utilesContext';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
export default function BoxSildebar() {

    const { openSilder, componentSilder, toogleOpenSilder, widthSilder, titleSilder } = useUtiles()
    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width: 600px)')
    return (
        <Drawer
            anchor="right"
            open={openSilder}
            onClose={toogleOpenSilder}
            keepMounted
            disableEnforceFocus
            disableAutoFocus={false}
            disableRestoreFocus={false}
            hideBackdrop={false}
            sx={{
                //zIndex: 10000,
                "& .MuiDrawer-paper": {
                    width: isMobile ? '100%' : widthSilder || 500,
                    boxSizing: 'border-box',
                    borderRadius: 0,
                },
            }}
        >
                <Box 
                    sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        padding: '10px',
                        alignItems: 'center',
                        borderBottom: `1px dotted ${theme.palette.divider}`
                    }}
                    role="presentation"
                >
                    <Typography variant="h6" sx={{fontWeight: 'bold', fontSize: '16px'}}>
                        {titleSilder}
                    </Typography>
                    <IconButton 
                        onClick={toogleOpenSilder} 
                        aria-label="cerrar panel lateral"
                        sx={{ color: theme.palette.text.primary }}
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
         
            <Box 
                sx={{ width: "100%", borderRadius: 0 }}
                role="dialog"
                aria-modal="true"
                aria-labelledby="drawer-title"
            >
                {componentSilder}
            </Box>
        </Drawer>
    )
}